export default "__VITE_ASSET__CFfjpJiS__"